// Canvas - Node Details Sidebar - English
export default {
  header: {
    addressDetails: "Address Details",
    contractDetails: "Contract Details",
  },
  loading: {
    text: "Loading...",
  },
  labels: {
    remark: "Remark:",
    none: "None",
    otherInfo: "Other Info",
    asset: "Assets",
    tradingStatistics: "Trading Statistics",
    transactionAnalysis: "Transaction Analysis",
    transactionDetails: "Transaction Details",
    tradingOpponent: "Counterparties",
    labelMissing: "Label Missing",
    dataLabel: "Data Label",
    labelCorrect: "Correct",
    labelTrace: "Trace",
  },
  tooltips: {
    edit: "Edit",
    addToMonitor: "Add to Monitor",
    addToDashboard: "Add to Dashboard",
  },
  survey: {
    normal: "Regular Survey",
    important: "Key Survey",
  },
  errors: {
    selectHint: "Please select a node or an edge on the canvas to view details",
    searchHintPrefix:
      "Search address/hash/case-user ID in the top bar,\nthen select a node or edge to view details",
    unsupportedChain: "This chain is not supported yet",
    noData: "No transaction data for the current address in the system",
    noAddressFound: "No results found for the address",
    dataNotFound: "No matching data found, please correct and try again",
  },
};
